// extracted by mini-css-extract-plugin
export var captionStyle = "caption_video-module--captionStyle--MkYc0";
export var captionVideoStyle = "caption_video-module--captionVideoStyle--EWJ0T";